import firebase from "firebase/app";
import "firebase/auth";

export const auth = firebase.initializeApp({
    apiKey: "AIzaSyDfWrwAdEAJ3qepH3atkNDCvwR4Szma75E",
    authDomain: "nchat-77129.firebaseapp.com",
    projectId: "nchat-77129",
    storageBucket: "nchat-77129.appspot.com",
    messagingSenderId: "1058270668005",
    appId: "1:1058270668005:web:9e429f4216e402cca0e00c",
    measurementId: "G-42RTR5YQPM"
}).auth();